<div class="app-sidebar__overlay" (click)="sidebarClose()"></div>

<div
  class="app-sidebar sticky"
  [ngClass]="{ 'fixed-header visible-title': scrolled }"
>
  <div class="sidebar-top-logo">
    <a class="top-desktop-logo" routerLink="/dashboard">
      <img [src]="sidebarLogo" alt="Logo" />
    </a>

    <a class="top-mobile-logo" routerLink="/dashboard">
      <img [src]="mobileLogo" alt="mobile-logo" />
    </a>
  </div>

  <ng-scrollbar>
    <div class="main-sidemenu">
      <div class="slide-left disabled d-none" id="slide-left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#7b8191"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
          />
        </svg>
      </div>

      <ul class="side-menu">
        <li
          *ngFor="let menuItem of menuItems"
          [ngClass]="{
            'side-item side-item-category': menuItem.headTitle,
            slide: menuItem.title,
            active: menuItem.active,
            'is-expanded': menuItem.active,
          }"
        >
          <ng-container *ngIf="menuItem.headTitle">
            {{ menuItem.headTitle | translate }}
          </ng-container>

          <div class="menu-container">
            <a
              class="side-menu__item has__link"
              *ngIf="menuItem.type === 'link'"
              [ngClass]="{ 'menu-locked': !!menuItem.locked }"
              [routerLink]="
                menuItem.locked || !menuItem.path ? null : [menuItem.path]
              "
              routerLinkActive="active"
              (click)="
                menuItem.locked
                  ? $event.preventDefault()
                  : toggleNavActive(menuItem)
              "
            >
              <span class="side-menu__icon">
                <i class="{{ menuItem.icon }}"></i>
              </span>
              <span class="side-menu__label">
                {{ menuItem.title || "" | translate }}
              </span>
              <i *ngIf="menuItem.locked" class="fe fe-lock menu-lock-icon"></i>
            </a>
          </div>

          <a
            class="side-menu__item has__link"
            href="javascript:;"
            *ngIf="menuItem.type === 'empty'"
            (click)="toggleNavActive(menuItem)"
          >
            <span class="shape1"></span>
            <span class="shape2"></span>
            <span class="side-menu__icon">
              <i class="fe fe-{{ menuItem.icon }}"></i>
            </span>
            <span class="side-menu__label">{{ menuItem.title }}</span>
          </a>

          <a
            class="side-menu__item has__link"
            routerLinkActive="active"
            target="_blank"
            [routerLink]="!menuItem.type ? null : [menuItem.path]"
            *ngIf="menuItem.type === 'external'"
            (click)="toggleNavActive(menuItem)"
          >
            <span class="side-menu__icon">
              <i class="fe fe-{{ menuItem.icon }}"></i>
            </span>
            <span class="side-menu__label">{{ menuItem.title }}</span>
            <span
              class="badge badge-sm bg-{{ menuItem.badgeClass }} badge-hide"
            >
              {{ menuItem.badgeValue }}
            </span>
          </a>

          <a
            class="side-menu__item"
            [routerLink]="menuItem.type ? null : [menuItem.path]"
            *ngIf="menuItem.type === 'sub'"
            (click)="
              menuItem.locked
                ? $event.preventDefault()
                : toggleNavActive(menuItem)
            "
            [ngClass]="{
              active: menuItem.active,
              'menu-locked': !!menuItem.locked,
            }"
          >
            <span class="shape1"></span>
            <span class="shape2"></span>
            <span class="side-menu__icon">
              <i class="{{ menuItem.icon }}"></i>
            </span>
            <span class="side-menu__label">
              {{ menuItem.title || "" | translate }}
            </span>
            <span
              class="{{ menuItem.badgeClass }}"
              *ngIf="menuItem.badgeClass && menuItem.badgeValue"
            >
              {{ menuItem.badgeValue }}
            </span>

            <i *ngIf="menuItem.locked" class="fe fe-lock menu-lock-icon"></i>
            <i
              *ngIf="!menuItem.locked"
              class="angle fe fe-chevron-right"
              [ngClass]="{ 'd-none': menuItem.badgeClass }"
            ></i>
          </a>

          <ul
            class="slide-menu"
            *ngIf="menuItem.children && menuItem.type === 'sub'"
            [ngClass]="{ open: menuItem.active }"
          >
            <li
              *ngFor="let childrenItem of menuItem.children"
              [ngClass]="{
                'is-expanded active': childrenItem.active,
                'sub-slide': childrenItem.Menusub,
              }"
            >
              <a
                class="slide-item"
                routerLinkActive="active"
                [ngClass]="{ 'menu-locked': !!childrenItem.locked }"
                [routerLink]="childrenItem.locked ? null : [childrenItem.path]"
                *ngIf="childrenItem.type === 'link'"
                (click)="
                  childrenItem.locked
                    ? $event.preventDefault()
                    : toggleNavActive(childrenItem)
                "
              >
                {{ childrenItem.title || "" | translate }}
                <i
                  *ngIf="childrenItem.locked"
                  class="fe fe-lock menu-lock-icon"
                ></i>
              </a>

              <a
                class="slide-item"
                routerLinkActive="active"
                href="javascript:;"
                *ngIf="childrenItem.type === 'empty'"
                (click)="toggleNavActive(childrenItem)"
              >
                {{ childrenItem.title }}
              </a>

              <a
                href="javascript:;"
                class="sub-side-menu__item"
                [routerLink]="childrenItem.type ? null : [childrenItem.path]"
                *ngIf="childrenItem.type === 'sub'"
                (click)="
                  childrenItem.locked
                    ? $event.preventDefault()
                    : toggleNavActive(childrenItem)
                "
                [ngClass]="{ 'menu-locked': !!childrenItem.locked }"
              >
                <span class="sub-side-menu__label">
                  {{ childrenItem.title }}
                </span>
                <i
                  *ngIf="childrenItem.locked"
                  class="fe fe-lock menu-lock-icon"
                ></i>
                <i
                  *ngIf="!childrenItem.locked"
                  class="sub-angle fe fe-chevron-right"
                ></i>
              </a>

              <ul
                class="sub-slide-menu"
                *ngIf="childrenItem.children"
                [ngClass]="{ open: childrenItem.active }"
              >
                <li
                  *ngFor="let childrenSubItem of childrenItem.children"
                  [ngClass]="{ 'is-expanded': childrenSubItem.active }"
                >
                  <a
                    class="sub-slide-item"
                    routerLinkActive="active"
                    [routerLink]="
                      !childrenSubItem.type ? null : [childrenSubItem.path]
                    "
                    *ngIf="childrenSubItem.type === 'link'"
                    (click)="toggleNavActive(childrenSubItem)"
                  >
                    {{ childrenSubItem.title }}
                  </a>

                  <a
                    class="sub-slide-item"
                    href="javascript:;"
                    *ngIf="childrenSubItem.type === 'empty'"
                    (click)="toggleNavActive(childrenSubItem)"
                  >
                    {{ childrenSubItem.title }}
                  </a>

                  <a
                    class="sub-slide-item"
                    href="javascript:;"
                    [routerLink]="
                      childrenSubItem.type ? null : [childrenSubItem.path]
                    "
                    *ngIf="childrenSubItem.type === 'sub'"
                    (click)="toggleNavActive(childrenSubItem)"
                  >
                    <span class="sub-side-menu__label2">
                      {{ childrenSubItem.title }}
                    </span>
                    <i class="sub-angle2 fe fe-chevron-right"></i>
                  </a>

                  <ul
                    class="sub-slide-menu2"
                    *ngIf="childrenSubItem.children"
                    [ngClass]="{ open: childrenSubItem.active }"
                  >
                    <li
                      *ngFor="let childrenSubItem1 of childrenSubItem.children"
                      [ngClass]="{ 'is-expanded': childrenSubItem1.active }"
                    >
                      <a
                        class="sub-slide-item2"
                        routerLinkActive="active"
                        [routerLink]="
                          !childrenSubItem1.type
                            ? null
                            : [childrenSubItem1.path]
                        "
                        *ngIf="childrenSubItem1.type === 'link'"
                      >
                        {{ childrenSubItem1.title }}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>

      <div class="slide-right d-none" id="slide-right">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#7b8191"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"
          />
        </svg>
      </div>
    </div>
  </ng-scrollbar>

  <div class="sidebar-bottom-logo">
    <img
      [src]="sidebarSolutionsLogo"
      class="bottom-desktop-logo"
      alt="solution"
    />
    <img [src]="solutionsIcon" class="bottom-mobile-logo" alt="solution" />
  </div>
</div>
